import prepareComponent from "@bluframe/grapple/prepareComponent"
import useToggle from "@bluframe/grapple/useToggle"
import { RefObject } from "react"

import CollapsibleTextArea from "./CollapsibleTextArea"

export interface Props {
  id?: string
  label: string
  name: string
  placeholder?: string
  rows?: number
  textAreaRef?: RefObject<HTMLTextAreaElement | null>
}

export interface ComponentProps extends Props {
  isShow: boolean
  onToggle: () => void
}

const usePrepareComponent = (props: Props): ComponentProps => {
  const [isShow, toggle] = useToggle()

  const onToggle = () => {
    toggle()
  }

  return {
    ...props,
    isShow,
    onToggle
  }
}

export default prepareComponent<Props, ComponentProps>(usePrepareComponent)(
  CollapsibleTextArea
)
